import { PatientOrderControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

type Params = {
  patientOrderId: string;
  status: string;
  xTENANTID?: string;
};

/**
 *
 * @author [Atish Bagate]
 */
export const usePatientOrderStatusUpdate = () =>
  useMutationWithLoading(async (params: Params) =>
    new PatientOrderControllerApi(getConfigObject()).updatePatientOrderStatus1(
      params.patientOrderId,
      params.status,
      params.xTENANTID
    )
  );
